/**
 * LAYOUT - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Light ops mode.
 */

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import FloatingActionMenu from '../ui/FloatingActionMenu';
import { COLORS } from '../../design/tokens';
import { useIsDesktop } from '../../hooks/useMediaQuery';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isDesktop = useIsDesktop();

  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: COLORS.bg.base }}>
      {/* Desktop Sidebar */}
      {isDesktop && (
        <div style={{ display: 'flex' }}>
          <Sidebar />
        </div>
      )}

      {/* Mobile Sidebar Drawer */}
      {!isDesktop && sidebarOpen && (
        <>
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 40,
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
            }}
            onClick={() => setSidebarOpen(false)}
          />
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 50,
              width: '256px',
              backgroundColor: COLORS.bg.panel,
              borderRight: `1px solid ${COLORS.border.default}`,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </>
      )}

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Navbar onOpenSidebar={() => setSidebarOpen(true)} />
        <main
          style={{
            flex: 1,
            overflowX: 'hidden',
            overflowY: 'auto',
            backgroundColor: COLORS.bg.base,
          }}
        >
          {children}
        </main>
        <FloatingActionMenu />
      </div>
    </div>
  );
};

export default Layout;
